export {
	SET_AUTH,
	setAuthAction
} from "./lib/authActions";


// WEBPACK FOOTER //
// src/actions/index.js